

import React, { useState } from 'react';
import styles from '../../assets/scss/Invoice/AddItemPopup.module.scss';
import { toast } from "react-toastify";
import { useSendItemCategoryMutation } from '../../slices/admin/admin';

const AddItemCategories = ({ onClose }) => {

    const [itemCategory, setItemCategory] = useState("");
    const [error, setError] = useState("");

    const [sendItemCategory, { isLoading }] = useSendItemCategoryMutation();

    // prevent first-space
    const handleInputChange = (e) => {
        let value = e.target.value;
        if (value.startsWith(" ")) return;

        setItemCategory(value);
        if (error) setError("");
    };

    const handleSubmit = async () => {
        if (!itemCategory.trim()) {
            setError("Item Category is required");
            toast.error("Item Category is required");
            return;
        }

        try {
            const body = { itemCategory };
            const res = await sendItemCategory(body).unwrap();
           toast.success(res?.message || "Item Category Added Successfully!");
            onClose();
        } catch (error) {
            const errorMessage =
                error?.data?.message ||
                error?.error ||
                "Failed to add item category";
            toast.error(errorMessage);
            setError(errorMessage);
        }
    };

    return (
        <div className={styles.popupForm}>

            <div className={styles.header}>
                <h2 className={styles.tittle}>Add Item Categories</h2>
                <span className={styles.closeIcons} onClick={onClose}>X</span>
            </div>

            <div className={styles.closeIcon}>
                <div className={styles.grid}>

                    <div className={styles.inputGroup}>
                        <label className={styles.inputLabel}>Item Categories</label>

                        <input
                            className={styles.input}
                            type="text"
                            placeholder="Item Categories"
                            value={itemCategory}
                            onChange={handleInputChange}
                            style={{ border: error ? "1px solid red" : undefined }}
                        />

                        {error && (
                            <span style={{ color: "red", fontSize: "12px" }}>
                                {error}
                            </span>
                        )}
                    </div>

                    <div className={styles.footerButtons}>
                        <button
                            type="button"
                            className={styles.cancel}
                            onClick={onClose}
                        >
                            Cancel
                        </button>

                        <button
                            type="button"
                            className={styles.save}
                            onClick={handleSubmit}
                            disabled={isLoading}
                        >
                            {isLoading ? "Adding..." : "Add"}
                        </button>
                    </div>

                </div>
            </div>

        </div>
    );
};

export default AddItemCategories;


// import React, { useState } from 'react';
// import styles from '../../assets/scss/Invoice/AddItemPopup.module.scss';
// import { toast } from "react-toastify";
// import { useSendItemCategoryMutation } from '../../slices/admin/admin';

// const AddItemCategories = ({ onClose }) => {

//     const [itemCategory, setItemCategory] = useState("");
//     const [description, setDescription] = useState("");
//     const [error, setError] = useState({});

//     const [sendItemCategory, { isLoading }] = useSendItemCategoryMutation();

//     // prevent first-space
//     const handleInputChange = (setter, field) => (e) => {
//         let value = e.target.value;
//         if (value.startsWith(" ")) return;

//         setter(value);
//         if (error[field]) {
//             setError(prev => ({ ...prev, [field]: "" }));
//         }
//     };

//     const handleSubmit = async () => {
//         let errors = {};

//         if (!itemCategory.trim()) {
//             errors.itemCategory = "Item Category is required";
//         }

//         // description optional – required venumna uncomment pannu
//         // if (!description.trim()) {
//         //     errors.description = "Description is required";
//         // }

//         if (Object.keys(errors).length) {
//             setError(errors);
//             toast.error("Please fill required fields");
//             return;
//         }

//         try {
//             const body = {
//                 itemCategory,
//                 description, // 👈 added
//             };

//             const res = await sendItemCategory(body).unwrap();
//             toast.success(res?.message || "Item Category Added Successfully!");
//             onClose();
//         } catch (err) {
//             const errorMessage =
//                 err?.data?.message ||
//                 err?.error ||
//                 "Failed to add item category";
//             toast.error(errorMessage);
//         }
//     };

//     return (
//         <div className={styles.popupForm}>

//             <div className={styles.header}>
//                 <h2 className={styles.tittle}>Add Item Categories</h2>
//                 <span className={styles.closeIcons} onClick={onClose}>X</span>
//             </div>

//             <div className={styles.closeIcon}>
//                 <div className={styles.grid}>

//                     {/* Item Category */}
//                     <div className={styles.inputGroup}>
//                         <label className={styles.inputLabel}>Item Categories</label>

//                         <input
//                             className={styles.input}
//                             type="text"
//                             placeholder="Item Categories"
//                             value={itemCategory}
//                             onChange={handleInputChange(setItemCategory, "itemCategory")}
//                             style={{ border: error.itemCategory ? "1px solid red" : undefined }}
//                         />

//                         {error.itemCategory && (
//                             <span style={{ color: "red", fontSize: "12px" }}>
//                                 {error.itemCategory}
//                             </span>
//                         )}
//                     </div>

//                     {/* Description */}
//                     <div className={styles.inputGroup}>
//                         <label className={styles.inputLabel}>Description</label>

//                         <input
//                             className={styles.input}
//                             type="text"
//                             placeholder="Description"
//                             value={description}
//                             onChange={handleInputChange(setDescription, "description")}
//                             style={{ border: error.description ? "1px solid red" : undefined }}
//                         />

//                         {error.description && (
//                             <span style={{ color: "red", fontSize: "12px" }}>
//                                 {error.description}
//                             </span>
//                         )}
//                     </div>

                  

//                 </div>
//                   <div className={styles.footerButtons}>
//                         <button
//                             type="button"
//                             className={styles.cancel}
//                             onClick={onClose}
//                         >
//                             Cancel
//                         </button>

//                         <button
//                             type="button"
//                             className={styles.save}
//                             onClick={handleSubmit}
//                             disabled={isLoading}
//                         >
//                             {isLoading ? "Adding..." : "Add"}
//                         </button>
//                     </div>
//             </div>

//         </div>
//     );
// };

// export default AddItemCategories;

